import { render, staticRenderFns } from "./BindDialog.vue?vue&type=template&id=5dc5b0e2&scoped=true"
import script from "./BindDialog.vue?vue&type=script&lang=js"
export * from "./BindDialog.vue?vue&type=script&lang=js"
import style0 from "./BindDialog.vue?vue&type=style&index=0&id=5dc5b0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5b0e2",
  null
  
)

export default component.exports